
import {
  apiAiKeyList,
  apiAiTypeList,
  apiAiKeyAdd,
  apiAiKeyEdit,
  apiAiConfigDel,
} from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import LsForm from "@/components/ls-form.vue";

@Component({
  components: {
    LsDialog,
    LsPagination,
    LsForm,
  },
})
export default class AiConfigList extends Vue {
  // 分页
  pager: RequestPaging = new RequestPaging();
  apiAiKeyList = apiAiKeyList;
  searchObj: any = {
    name: "",
  };
  mode = "add";
  dataForm: any = {};
  typeList: any = [];
  configForm: any = [];
  formData: any = [
    {
      type: "input",
      label: "名称",
      key: "name",
      rules: [{ required: true, message: "请输入名称", trigger: "blur" }],
    },
    {
      type: "input",
      label: "api_key",
      key: "api_key",
      rules: [{ required: true, message: "请输入api_key", trigger: "blur" }],
    },
    {
      type: "select",
      label: "平台",
      key: "ai_type",
      list: [],
      rules: [{ required: true, message: "请选择平台", trigger: "change" }],
    },
  ];
  formVisible = false;
  // 获取列表
  getList() {
    this.pager.request({
      callback: apiAiKeyList,
      params: this.searchObj,
    });
  }

  handleAdd() {
    this.dataForm = {
      id: "",
      name: "",
      api_key: "",
      ai_type: "",
    };
    const baseFormItems = this.formData.slice(0, 3);
    this.formData = [...baseFormItems];
    this.mode = "add";
    this.formVisible = true;
  }

  async handleEdit(row: any) {
    this.dataForm = {
      id: row.id,
      name: row.name,
      api_key: row.api_key,
      ai_type: row.ai_type,
    };

    await this.$nextTick();
    this.mode = "edit";
    this.formVisible = true;
  }

  handleSubmit(value: object) {
    this.dataForm = value;
    if (this.mode == "add") {
      apiAiKeyAdd(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiAiKeyEdit(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  gettypeList() {
    apiAiTypeList({}).then((res) => {
      this.typeList = res.map((item: any) => ({
        label: item.name,
        value: item.type,
      }));

      this.formData.find((item: any) => item.key == "ai_type").list =
        this.typeList;
    });
  }
  handleDelete(id: number) {
    apiAiConfigDel({ id: id }).then((res: any) => {
      this.$message.success("删除成功");
      this.getList();
    });
  }

  created() {
    this.getList();
    this.gettypeList();
  }
}
